//
// mapwrapper
//
// Code wrapped around the OL map itself, for manipulating it. This is the
// interface through which Vue should access OpenLayers.
//

import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer'
import {Vector as VectorSource} from 'ol/source'
import {Style, Stroke} from 'ol/style'
import {Map, View} from 'ol'
import GeoJSON from 'ol/format/GeoJSON'
import {transform} from 'ol/proj'

/**
 * Private module things - mostly map things that need manipulating.
 */

// The OpenLayers map.
let map

// The OSM map layer.
let mapLayer

// The Vector layer for an A-road
let roadLayer

// The source for the roads.
let roadSource = new VectorSource()

// The padding around the road features
let padding = 20

/**
 * Expose the Map Layer for code to use directly.
 */
export function getMapLayer() {
    return mapLayer
}

/**
 * Expose the ol Map for code to use directly.
 */
export function getMap() {
    return map
}

/**
 * buildMap
 */
export function buildMap(id, source) {
    mapLayer = new TileLayer({
        projection: 'EPSG:3857',
        source: source.source,
        className: source.class
    })

    roadLayer = new VectorLayer({
        source: roadSource,
        style: new Style({
            stroke: new Stroke({
                color: 'rgba(255, 100, 100, 1.0)',
                width: 5,
                lineCap: "round"
            })
        }),
        renderMode: 'image'
    })

    const dunsopBridge = new View({
        center: transform(
            [-2.5200, 53.9460], 'EPSG:4326', 'EPSG:3857'
        ),
        zoom: 8,
        projection: 'EPSG:3857'
    })

    map = new Map({
        target: document.getElementById(id),
        layers: [mapLayer, roadLayer],
        controls: [],
        view: dunsopBridge,
    })
}

/**
 * processRoad
 */
export function processRoad(data, number) {
    let features = new GeoJSON().readFeatures(data)
    features.forEach((f) => {
        f.setId("A" + number)
    })
    roadSource.addFeatures(features)
    const extent = roadSource.getExtent()
    const p = padding
    map.getView().fit(extent, {padding: [p, p, p, p]})
}

/**
 * setPadding
 */
export function setPadding(p) {
    padding = p
}

/**
 * removeRoad
 */
export function removeRoad(number) {
    roadSource.removeFeature(
        roadSource.getFeatureById("A" + number)
    )
}

/**
 * clearRoads
 */
export function clearRoads() {
    roadSource.clear()
}

